import React from "react";
import "whatwg-fetch";
import TrackList from "../Tracklist/index.jsx";
import TabNav from "../TabNav/index.jsx";
import TabBody from "../TabBody/index.jsx";
import Player from "../Player/index.jsx";
import { TrackContext } from "../TrackContext.jsx";

const App = () => {
  const { tracks, trackIds, activeTrackIndex } = React.useContext(TrackContext);
  const [activeTrack, setActiveTrack] = React.useState(tracks[trackIds[0]]);
  const [activeTab, setActiveTab] = React.useState("lyrics");
  const tabs = {
    lyrics: "Lyrics",
    linerNotes: "Credits"
  };

  React.useEffect(() => {
    setActiveTrack(tracks[trackIds[activeTrackIndex]]);
  }, [activeTrackIndex]);

  const handleTrackClick = id => () => {
    setActiveTrack(tracks[id]);
  };

  const handleTabClick = key => () => {
    setActiveTab(key);
  };

  return (
    <div className="l-album-player">
      <div className="l-album-player__tracks">
        <TrackList
          activeTrack={activeTrack.id}
          tracks={tracks}
          onTrackClick={handleTrackClick}
        />
        <div className="all-notes">
          <a href="notes" className="all-notes-link">
            View All Creative Notes
          </a>
        </div>
      </div>

      <div className="l-album-player__body">
        <div className="player-head">
          <div className="player-wrap">
            <Player track={activeTrack} />
          </div>
          <div>
            <TabNav
              keyColor={activeTrack.keyColor}
              onTabClick={handleTabClick}
              tabs={tabs}
              activeTab={activeTab}
            />
          </div>
        </div>
        <TabBody activeTrack={activeTrack} activeTab={activeTab} />
      </div>
    </div>
  );
};

export default App;
